import { render } from "./j-input.vue?vue&type=template&id=7696ae9e&scoped=true"
import script from "./j-input.vue?vue&type=script&lang=js"
export * from "./j-input.vue?vue&type=script&lang=js"

import "./j-input.vue?vue&type=style&index=0&id=7696ae9e&lang=less&scoped=true"

import exportComponent from "/Users/jiangwen/GitHub/xiamao-mall/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7696ae9e"]])

export default __exports__